import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { findCounterpartPath } from '../lib/localizedPaths';

const LanguageToggle = ({ variant = 'default' }) => {
  const { language, toggleLanguage } = useLanguage();
  const location = useLocation();
  const navigate  = useNavigate();

  // Switch language AND, if the current URL has a registered counterpart in the
  // target language, navigate to it — so the URL slug reflects the new language.
  const switchTo = (target) => {
    if (language === target) return;
    const counterpart = findCounterpartPath(location.pathname, target);
    toggleLanguage();
    if (counterpart && counterpart !== location.pathname) {
      navigate(counterpart + location.search + location.hash, { replace: true });
    }
  };

  /* ── Standart pill toggle (header/admin sayfaları için) ── */
  if (variant === 'pill' || variant === 'admin' || variant === 'default') {
    return (
      <div className="flex items-center rounded-full border border-gray-200 overflow-hidden bg-gray-100 p-0.5 gap-0.5">
        <button
          onClick={() => switchTo('tr')}
          className={`px-3 py-1 rounded-full text-xs font-semibold transition-all ${
            language === 'tr'
              ? 'bg-white text-gray-800 shadow-sm'
              : 'text-gray-400 hover:text-gray-600'
          }`}
        >
          TR
        </button>
        <button
          onClick={() => switchTo('en')}
          className={`px-3 py-1 rounded-full text-xs font-semibold transition-all ${
            language === 'en'
              ? 'bg-white text-gray-800 shadow-sm'
              : 'text-gray-400 hover:text-gray-600'
          }`}
        >
          EN
        </button>
      </div>
    );
  }

  /* ── Navbar varyantı (landing page) ── */
  if (variant === 'navbar') {
    return (
      <div className="flex items-center rounded-full bg-white/10 backdrop-blur-sm overflow-hidden p-0.5 gap-0.5">
        <button
          onClick={() => switchTo('tr')}
          className={`px-3 py-1.5 rounded-full text-sm font-semibold transition-all ${
            language === 'tr' ? 'bg-white text-emerald-900' : 'text-white hover:bg-white/20'
          }`}
        >
          TR
        </button>
        <button
          onClick={() => switchTo('en')}
          className={`px-3 py-1.5 rounded-full text-sm font-semibold transition-all ${
            language === 'en' ? 'bg-white text-emerald-900' : 'text-white hover:bg-white/20'
          }`}
        >
          EN
        </button>
      </div>
    );
  }

  return null;
};

export default LanguageToggle;